import { render, staticRenderFns } from "./SectionIndex.vue?vue&type=template&id=268ae4a1&scoped=true&"
import script from "./SectionIndex.vue?vue&type=script&lang=js&"
export * from "./SectionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268ae4a1",
  null
  
)

export default component.exports